import { Button, Col } from "reactstrap";
import { Form, Formik } from "formik";
import { stateSchema } from "./validation";
import TextBox from "../../../components/common/textBox";
const AddUpdateTerms = (props: any) => {
  const { api, value, closeAddUpdate } = props;
  return (
    <Formik
      validationSchema={stateSchema}
      initialValues={{
        ...value,
        title: value?.title
          ? value.title
          : "",
      }}
      enableReinitialize={true}
      onSubmit={(values: any, actions: any) => {
        if (values.id) {
          api.updateValue(values).then((result: any) => {
            if (result?.status) {
              closeAddUpdate();
            }
          });
        } else {
          api.create(values).then((result: any) => {
            if (result?.status) {
              closeAddUpdate();
            }
          });
        }
      }}
    >
      {({ values, isSubmitting, setFieldValue }) => (
        <Form className="form-main">
  
          <TextBox
            fieldName={"title"}
            placeholder={"Enter Terms & Conditions Name"}
            className={"form-control"}
            type={"text"}
            isRequired={true}
            labelName={"Terms & Conditions Name"}
            value={value}
          />
          <TextBox
            fieldName={"description"}
            placeholder={"Enter description"}
            className={"form-control"}
            type={"textarea"}
            isRequired={true}
            rows="4"
            labelName={"Description"}
            value={value}
          />
          <Col lg="12" className="d-flex justify-content-end gap-2">
            <Button
              color="secondary"
              outline
              type="button"
              onClick={() => closeAddUpdate()}
            >
              Cancel
            </Button>
            <Button color="secondary" solid type="submit">
              {value?.id > 0 ? "Update" : "Submit"}
            </Button>
          </Col>
        </Form>
      )}
    </Formik>
  );
};
export { AddUpdateTerms };
